import { render, staticRenderFns } from "./VendorSitesTab.vue?vue&type=template&id=98d7c128"
import script from "./VendorSitesTab.vue?vue&type=script&lang=js"
export * from "./VendorSitesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports